<script>
  import {getContext} from 'svelte';
  import {LINKS} from '@/const/link';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import {fiatABTest$} from '@/modules/fiat/streams';
  import SkeletonLoginView from '@/widgets/skeleton/LoginView.svelte';
  import MenuSkeleton from './MenuSkeleton.svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
  let menu = [];

  $: menu = getMenuList($fiatABTest$);

  function getMenuList(fiatABTest) {
    return [
      {
        title: LG(lang.MenuTitle1),
        desc: LG(lang.MenuDesc1),
        icon: 'BUY_CRYPTO',
        href: $fixLink$(fiatABTest ? PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname : PATHS.OTC_LEGEND_TRADING.pathname),
        name: 'buy_crypto',
      },
      {
        title: LG(lang.MenuTitle2),
        desc: LG(lang.MenuDesc2),
        icon: 'SPOT_TRADING',
        href: '/spot/trade/BTCUSDT',
        name: 'spot_trading',
      },
      {
        title: LG(lang.MenuTitle3),
        desc: LG(lang.MenuDesc3),
        icon: 'CONTRACT',
        href: '/trade/BTCUSDT',
        name: 'contract_trading',
      },
      {
        title: LG(lang.MenuMarginTradeTitle),
        desc: LG(lang.MenuMarginTradeDesc),
        icon: 'MARGIN_TRADING',
        href: LINKS.PHEMEX_SPOT_MARGIN_TRADE + '/BTCUSDT',
        name: 'margin_trading',
      },
      {
        title: LG(lang.MenuTitle5),
        desc: LG(lang.MenuDesc5),
        icon: 'BONUS',
        href: $fixLink$(PATHS.BONUS.pathname),
        name: 'rewards_hub',
      },
      {
        title: LG(lang.MenuTitle6),
        desc: LG(lang.MenuDesc6),
        icon: 'REFERRAL',
        href: $fixLink$(PATHS.ACCOUNT_INVITE_FRIENDS.pathname),
        name: 'referral',
      },
    ];
  }

  function clickHandler(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'resource_' + item.name});
      location.href = item.href;
    };
  }
</script>

<style>
  .wrap {
    background: #f6f7fb;
  }
  .main {
    margin: 0 auto;
    width: 1200px;
  }
  .menu {
    display: flex;
    justify-content: space-between;
  }
  .item {
    box-sizing: border-box;
    border-left: 1px solid #e2e4e9;
    padding: 0 0 0 16px;
  }
  .item:hover div {
    color: var(--blue);
  }
  .item:first-child {
    border-left: none;
    padding-left: 0;
  }
  :global(html[lang='es-ES']) .title {
    font-size: 14px;
  }
  .desc {
    padding: 4px 0;
  }
  .item:last-child {
    padding-right: 0;
  }
  .con {
    display: grid;
    grid-template-columns: repeat(6, auto);
  }
  @media screen and (max-width: 640px) {
    .main {
      width: 100%;
    }
    .menu {
      flex-wrap: wrap;
      margin: 0;
    }
    .item,
    .item:first-child,
    .item:last-child {
      border-left: none;
      padding: 20px 8px;
      width: 50%;
    }
    .con {
      grid-template-rows: 86px 86px 86px;
      grid-template-columns: 1fr 1fr;
    }
  }
</style>

<div class="wrap">
  <div class="main pv24">
    <SkeletonLoginView height="44px">
      <div slot="init" class="con">
        {#each new Array(6).fill(0) as item}
          <MenuSkeleton />
        {/each}
      </div>
      <div class="menu">
        {#each menu as item}
          <div class="item fl df cp" on:click={clickHandler(item)}>
            <img width="32" height="32" src={IMAGES[item.icon]} alt={item.title} />
            <div class="ml12 T1 f12">
              <div class="title f16 fw3">{item.title}</div>
              <div class="desc">{@html item.desc}</div>
            </div>
          </div>
        {/each}
      </div>
    </SkeletonLoginView>
  </div>
</div>
